import axios from "axios";
import {toast} from "react-toastify";
import config from "../constants";
import {ref} from "joi";

const refreshUrl = '/accounts/token/refresh/';


const axiosInstance = axios.create({
    baseURL: config.API_URL,
    timeout: 50000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json'
    }
});

axiosInstance.interceptors.response.use(null, async error => {

    if (error.message === 'Network Error') {
        // this occurs when the API isn't online/reachable - how to handle?
        toast.error("Es ist ein Fehler aufgetreten.");
        return Promise.reject(error);
    }
    // if unauthorized, refresh the token
    if (error.response.status === 401) {
        // console.log('auth error')
        const originalRequest = error.config;

        // Don't auto-redirect for auth status checks - let AuthContext handle it
        if (originalRequest['url'] === '/users/me/') {
            throw error.response;
        }

        if (originalRequest['url'] !== refreshUrl) {
            return await refreshToken(error, originalRequest)
        } else {
            // force logout if still not authenticated - cookies will be cleared by backend
            if(window.location.pathname !== '/login'){
                window.location = '/login'
            }
        }
    } else {
        throw error.response
    }

    const expectedError =
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500;

    if (!expectedError) {
        // logger.log(error);
        toast.error("Es ist ein Fehler aufgetreten.");
    }

    return Promise.reject(error);
});

function setJwt(jwt) {
    // No longer needed - cookies handle authentication
    // Keeping for backward compatibility during transition
}

function removeJwt(jwt) {
    // No longer needed - cookies handle authentication
    // Keeping for backward compatibility during transition
}

function refreshToken(error, originalRequest) {
    // Backend now handles refresh token from cookies automatically
    return axiosInstance
        .post(refreshUrl)
        .then((response) => {
            // Backend returns { "message": "Token refreshed successfully" }
            // No need to store tokens - they're in httpOnly cookies
            if (originalRequest) {
                // Retry the original request - cookies will be sent automatically
                return axiosInstance(originalRequest);
            }
        })
        .catch(err => {
            if (err.response && (err.response.status === 401 || err.response.status === 400)) {
                // Redirect to login - backend will clear cookies
                window.location = '/login'
            }
        });
}

const httpService = {
    get: axiosInstance.get,
    post: axiosInstance.post,
    put: axiosInstance.put,
    patch: axiosInstance.patch,
    delete: axiosInstance.delete,
    options: axiosInstance.options,
    setJwt,
    removeJwt,
    refreshToken
}

export default httpService;
